import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

class BrowserView extends Component {
    render () {
        return (
            <div className='browser interaction'>
                <div className='fixed'>
                    <div className='window-buttons'>
                        <div className='btn-circle' />
                        <div className='btn-circle' />
                        <div className='btn-circle' />
                    </div>
                    <header>
                        <span className='rounded-input'>{ this.props.data.title }</span>
                    </header>
                </div>
                <div className='content'>
                    <div className='card'>
                        <span>{ this.props.data.message }</span>
                    </div>
                    <div className='btn' onClick={() => this.props.push('/')}>
                        <h4>Voltar</h4>
                    </div>
                </div>
            </div>
        );
    }
};

export default connect(null, {push})(BrowserView);



// WEBPACK FOOTER //
// ./src/views/InteractionViews/browserView.js